import { assets } from '@pukka/common';
import { twMerge } from 'tailwind-merge';

import { Loader } from '../Loader';

interface NoDataDisplayProps {
  readonly isLoading: boolean;
  readonly placeholder?: (() => string | React.ReactElement | React.ReactNode) | React.ReactNode;
  readonly imageSize?: number;
  readonly className?: string;
}

const { noData } = assets;

function NoDataDisplay({ isLoading, placeholder, imageSize = 200, className }: NoDataDisplayProps) {
  return (
    <div className={twMerge('flex h-full flex-col items-center justify-center border border-neutral-200', className)}>
      {isLoading ? (
        <Loader size={64} />
      ) : (
        <>
          <img src={noData} alt="no data in the table" width={imageSize} />
          <h2 className="mb-4 mt-7 text-lg font-medium">No Data To Display</h2>
          {placeholder && typeof placeholder === 'function' ? placeholder() : null}
          {placeholder && typeof placeholder !== 'function' ? placeholder : null}
        </>
      )}
    </div>
  );
}

export { NoDataDisplay };
